import { render, staticRenderFns } from "./FormDropdownQuestion.vue?vue&type=template&id=fb716fb4"
import script from "./FormDropdownQuestion.vue?vue&type=script&lang=js"
export * from "./FormDropdownQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports